// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1pbVh","colBig":"styles_colBig__Atrhp","colSmall":"styles_colSmall__1UqTM"};